export const staircaseConfig = {
    gameSlug: 'target-tracker',
    category: 'air_attention',
    variable: 'n_items',
    startValue: 2,
    minValue: 1,
    maxValue: 8,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    // MVP : 24 essais max, < 3 min test live.
    maxTrials: 24,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, targetSpeed: 80, trackingDurationMs: 4000, label: 'Pursuit lent' };
    }
    if (level <= 20) {
        return { level, targetSpeed: 110, trackingDurationMs: 5000, label: 'Vitesse modérée' };
    }
    if (level <= 30) {
        return { level, targetSpeed: 140, trackingDurationMs: 5500, label: 'Filtrage actif' };
    }
    if (level <= 40) {
        return { level, targetSpeed: 170, trackingDurationMs: 6000, label: 'Ré-identification' };
    }
    return { level, targetSpeed: 200, trackingDurationMs: 7000, label: 'Limite suivie' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase. */
export const timing = {
    fixationMs: 500,
    feedbackMs: 600,
    itiMs: 700,
    /** Durée du highlight initial (ms) — la cible reste marquée pour ce temps. */
    highlightMs: 800,
};
export const paradigmMeta = {
    slug: 'target-tracker',
    paradigm: 'Multiple Object Tracking — Pursuit (Pylyshyn 1988 / Pew 1965)',
    masterMage: 'Inori (air-attention)',
    category: 'air_attention',
    goal: 'Suivi visuel sous distracteurs : sport, conduite, attention divisée.',
};
//# sourceMappingURL=params.js.map